import React, { useEffect, useState } from 'react'
import { Form, Message, Modal } from 'semantic-ui-react'
import { X } from 'phosphor-react'
import styled from 'styled-components'
import { AppDangerButton, AppSecondaryButton } from 'elements'
import { FlexRowBetween } from 'components'
import { REJECTION_CATEGORIES, buildRejectPayload } from './report-approval-utils'

const RejectModal = styled(Modal)`
    .content {
        padding: 1.5rem !important;
    }
`

export const RejectReportModal = ({
    open,
    onClose,
    onSubmit,
    submitting = false,
    error = '',
    auditorName = 'the auditor',
}) => {
    const [reason, setReason] = useState('')
    const [category, setCategory] = useState(REJECTION_CATEGORIES[0].value)
    const [validationError, setValidationError] = useState('')

    useEffect(() => {
        if (!open) {
            setReason('')
            setCategory(REJECTION_CATEGORIES[0].value)
            setValidationError('')
        }
    }, [open])

    const handleSubmit = () => {
        if (!reason.trim() || reason.trim().length < 5) {
            setValidationError('Please enter a specific reason (at least 5 characters).')
            return
        }
        onSubmit(buildRejectPayload({ reason, category }))
    }

    return (
        <RejectModal
            open={open}
            onClose={onClose}
            size="small"
            closeOnDimmerClick={false}
        >
            <Modal.Header>
                <FlexRowBetween>
                    <span style={{ color: '#dc2626' }}>Reject this report?</span>
                    <X className="pointer" size={24} onClick={onClose} />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <p style={{ color: '#7f1d1d', fontSize: 13 }}>
                    The report will be sent back to <strong>{auditorName}</strong> to
                    fix. Later approvers do not see it until it is re-submitted
                    from step 1.
                </p>
                {(validationError || error) && (
                    <Message negative size="small">
                        {validationError || error}
                    </Message>
                )}
                <Form>
                    <Form.TextArea
                        required
                        label="Reason for rejection"
                        placeholder="What needs to change? Be specific — this text is shown to the auditor."
                        value={reason}
                        onChange={(_, { value }) => setReason(value)}
                        rows={3}
                    />
                    <Form.Dropdown
                        label="Category"
                        selection
                        options={REJECTION_CATEGORIES.map(opt => ({
                            key: opt.value,
                            value: opt.value,
                            text: opt.text,
                        }))}
                        value={category}
                        onChange={(_, { value }) => setCategory(value)}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <AppSecondaryButton type="button" onClick={onClose}>
                    Cancel
                </AppSecondaryButton>
                <AppDangerButton
                    type="button"
                    onClick={handleSubmit}
                    disabled={submitting}
                >
                    {submitting ? 'Rejecting…' : 'Confirm rejection'}
                </AppDangerButton>
            </Modal.Actions>
        </RejectModal>
    )
}
